import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Select from "react-select";

import { REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL } from "config";
import GroupForm from "pages/NewGroup/components/GroupForm";

const UpdateGroup = () => {
  const [group, setGroup] = useState(null);
  useEffect(() => {
    getAndSetGroup();
  }, []);
  const getAndSetGroup = () => {
    const groupId = window.location.pathname.split("/").pop();
    axios
      .get(
        `${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/groups/${groupId}`
      )
      .then((res) => {
        setGroup({
          ...res.data.group,
          childGroups: res.data.group.childGroups || [],
        });
      })
      .catch((err) => {
        console.log("err: ", err);
      });
  };
  return (
    <div class="page">
      <h1>Update Group</h1>
      {group?._id ? <GroupForm initialValues={group} /> : "not loaded"}
    </div>
  );
};

export default UpdateGroup;
